var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import CompPathBreadcrumb from './CompPathBreadcrumb';
import TriggersToolbarWidget from './TriggersToolbarWidget';
import MoreToolbarWidget from './MoreToolbarWidget';
import ZoomToolbarWidget from './ZoomToolbarWidget';
import PageWidthToolbarWidget from './PageWidthToolbarWidget';
// 放在组件框顶部的那种
let UcdToolbar = class UcdToolbar extends Vue {
  get showTriggersToolbarWidget() {
    return !this.designer.skeletonStyle.hideTriggersToolbarWidget;
  }
  handleSpacerClick() {
    this.designer.compPath = '';
  }
  get widgets() {
    const h = this.$createElement;
    const {
      toolBarFilter
    } = this.uc.config.designerUiConfig;
    return [{
      id: 'compPath',
      render: () => h(CompPathBreadcrumb)
    }, {
      id: '',
      render: () => h("div", {
        "class": "ucd-toolbar-spacer",
        "on": {
          "click": this.handleSpacerClick
        }
      })
    }, {
      id: 'pageWidth',
      render: () => h(PageWidthToolbarWidget)
    }, {
      id: 'zoom',
      render: () => h(ZoomToolbarWidget)
    }, {
      id: 'trigger',
      render: () => this.showTriggersToolbarWidget && h(TriggersToolbarWidget)
    }, {
      id: 'more',
      render: () => h(MoreToolbarWidget)
    }].filter(toolBarFilter);
  }
  render() {
    const h = arguments[0];
    const {
      scopeStack
    } = this.designer;
    const exitScopeButton = scopeStack.length > 0 && h("button", {
      "attrs": {
        "type": "button"
      },
      "class": "ucd-toolbar-button ucd-toolbar-exitScope",
      "on": {
        "click": () => this.designer.exitScope()
      }
    }, [h("i", {
      "class": "fa fa-reply",
      "attrs": {
        "aria-hidden": "true"
      }
    }), "\u56DE\u5230\u4E0A\u5C42"]);
    return h("div", {
      "class": "ucd-toolbar",
      "attrs": {
        "data-ucd-report-mod": "工具栏"
      }
    }, [exitScopeButton, this.widgets.map(item => item.render())]);
  }
};
__decorate([Inject(INJECT_UICORE_BUS)], UcdToolbar.prototype, "uc", void 0);
__decorate([Inject(INJECT_UICORE_DESIGNER)], UcdToolbar.prototype, "designer", void 0);
UcdToolbar = __decorate([Component({
  name: 'UcdToolbar'
})], UcdToolbar);
export default UcdToolbar;
//# sourceMappingURL=index.js.map
